export default "__VITE_ASSET__DsMwgB5X__"